import { Form } from 'factorial-form'
import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { isEditable } from 'modules/custom_resources/lib/utils'
import { RatingDefaultValues } from 'modules/custom_resources/store/collections/customFields/fields'
import type Field from 'modules/custom_resources/store/models/customResources/Field'
import type Resource from 'modules/custom_resources/store/models/customResources/Resource'
import type Schema from 'modules/custom_resources/store/models/customResources/Schema'
import type Value from 'modules/custom_resources/store/models/customResources/Value'
import type Employee from 'modules/employees/store/models/Employee'

import coerceValueFromType from './coerceValueFromType'
import getValueType from './getValueType'

interface Props {
  schema: Schema | undefined
  field: Field
  resource?: Resource | null | undefined
  currentValue?: Value
  employee?: Employee
  contractVersions: ContractVersions
}

// TODO: check type after TS migration
// type FormProps = {
//   field_id: number,
//   field_type: string,
//   resource_id?: number,
//   editable: boolean,
//   mandatory: boolean,
//   name: string,
//   visible: boolean,
//   value: string | number | null | boolean | Array<string>
// }
const createForm = ({
  schema,
  field,
  resource,
  currentValue,
  employee,
  contractVersions,
}: Props): Form => {
  const dataValue = (): Record<string, any> => {
    if (!currentValue) {
      if (schema?.attributes.effective_at_id === field.attributes.id) {
        return {
          value: dateToString(moment(), 'backend'),
        }
      } else {
        return {}
      }
    }

    return {
      value: coerceValueFromType(field, currentValue),
    }
  }

  const name =
    schema?.attributes.effective_at_id === field.attributes.id
      ? i18n.t('custom_resources.schema.effective_at_label')
      : field.attributes.label

  const data = {
    field_id: field.attributes.id,
    field_type: field.attributes.field_type,
    // TODO: An schema can have multiple resources for the same attachable (being defined)
    resource_id: resource?.attributes.id,
    editable: employee ? isEditable(field.attributes.editable, contractVersions, employee) : true,
    options: field.attributes.options,
    installed: true,
    mandatory: field.attributes.required,
    withNullLabel: field.has('withNullLabel') && field.attributes.withNullLabel,
    choice_options: field.attributes.choice_options,
    min_value: field.has('min_value') ? field.attributes.min_value : RatingDefaultValues.minValue,
    max_value: field.has('max_value') ? field.attributes.max_value : RatingDefaultValues.maxValue,
    name: name,
    visible: true,
    ...dataValue(),
  }

  return new Form(data, {
    field_id: 'number',
    field_type: 'string',
    resource_id: 'number',
    editable: 'boolean',
    mandatory: 'boolean',
    name: 'string',
    installed: 'boolean',
    options: 'string',
    withNullLabel: 'string',
    choice_options: 'string',
    min_value: 'number',
    max_value: 'number',
    value: getValueType(field.attributes.field_type),
    visible: 'boolean',
  })
}

export default createForm
